import {
  OFFER_INCREMENT_STEP,
  OFFER_DECREMENT_STEP,
  OFFER_SET_CURRENT_STEP,
  OFFER_UPDATE_PARAMS,
  OFFER_UPDATE,
  OFFER_COOKIE_SUCCESS,
  OFFER_UPDATE_OPERATION,
  PRECONTRACT_UPDATE,
  OFFER_CREATE_OPERATION_DATA,
  OFFER_UPDATE_DOCUMENTS_REQUIRED,
  OFFER_UPDATE_SIGN,
  OFFER_REGISTER_SIGNATURE,
  OFFER_UPDATE_COMPLETED_KO,
  OFFER_LEGAL_CONDITIONS,
  OFFER_COMPONENTS_BY_PARTNER_ID,
  OFFER_SET_GUID_URL,
  OFFER_UPDATE_OPERATION_ID,
  OFFER_UPDATE_PARTNERID,
  SET_OFFERDETAIL_NAME
} from 'store/actions/offer';
import { number, currency } from 'helpers/number';
import { dateToISO } from 'helpers/date';

export default {
  [OFFER_INCREMENT_STEP]: state => {
    state.currentStep += 1;
  },

  [OFFER_DECREMENT_STEP]: state => {
    state.currentStep -= 1;
  },

  [OFFER_SET_CURRENT_STEP]: (state, currentStep) => {
    state.currentStep = currentStep;
  },

  [OFFER_UPDATE_PARAMS]: (state, resp) => {
    const { idOffer, partnerId, idc, guid } = resp;
    state.idOffer = Number(idOffer);
    state.idc = idc ? Number(idc) : 0;
    state.partnerId = Number(partnerId);
    state.guidURL = guid;
  },

  [OFFER_UPDATE_PARTNERID]: (state, resp) => {
    const { partnerId } = resp;
    state.partnerId = Number(partnerId);
  },
  [OFFER_COOKIE_SUCCESS]: (state, resp) => {
    state.statusCookie = resp.idStatus;
    state.referenceNumber = resp.referenceNumber;
  },

  // eslint-disable-next-line complexity
  [OFFER_UPDATE]: (state, offer) => {
    state.offer = offer;
    const { serviceList, campaignDetail, partnerId, campaignId, car } = offer;
    if (partnerId) state.partnerId = Number(partnerId);
    if (campaignId) state.idOffer = Number(campaignId);
    if (campaignDetail && campaignDetail.channel && campaignDetail.channel.length > 0) {
      state.amazonChannel = campaignDetail.channel.indexOf('Amazon') > -1;
    }
    // Bulletpoints
    const bulletPoints = car.bulletPoints || [];
    let extraInformation = '';
    bulletPoints.forEach((element, index) => {
      if (index === 0) extraInformation = '<ul>';
      extraInformation += `<li>${element}</li>`;
      if (bulletPoints.length - 1 === index) extraInformation += '</ul>';
    });
    // Created offer detail object
    state.offerDetail = {
      title: `${campaignDetail.make} ${campaignDetail.model}`,
      subTitle: campaignDetail.version,
      badgeCampaignType: car && car.vehicleStatus ? car.vehicleStatus : null,
      badgeColor: car && car.colorName ? `Color ${car.colorName}` : null,
      badgeRangeKms: campaignDetail.rangeKms,
      legal: campaignDetail.legalText,
      phone: campaignDetail.phone,
      email: campaignDetail.email,
      photos: campaignDetail.urlPhoto,
      value: `${currency(campaignDetail.monthFee)}/mes`,
      properties: [
        {
          name: 'Tipo:',
          description: `${campaignDetail.vehicleType} ${campaignDetail.doors} puertas.`
        },
        {
          name: 'Opciones incluidas:',
          description: campaignDetail.accessories
        },
        {
          name: 'Servicios incluidos:',
          description: serviceList
        },
        {
          name: 'Ajustes de kilometraje:',
          description: campaignDetail.settings
        }
      ],
      features: [
        {
          title: 'Plazo',
          value: `${campaignDetail.termInMonths} meses`,
          icon: 'clock-o'
        },
        {
          title: 'Km/año',
          value: number(campaignDetail.yearKms),
          icon: 'tachometer'
        }
      ],
      extraInformation
    };

    if (campaignDetail.warrantyFeeDescription) {
      state.offerDetail.properties.push({
        name: 'A la firma del contrato:',
        description: campaignDetail.warrantyFeeDescription
      });
    }

    if (campaignDetail.downPayment != null) {
      state.offerDetail.features.push({
        title: 'Aportación inicial',
        value: currency(campaignDetail.downPayment),
        icon: 'euro'
      });
    }

    if (campaignDetail.warrantyFee != null) {
      state.offerDetail.features.push({
        title: 'Depósito en garantía',
        value: currency(campaignDetail.warrantyFee),
        icon: 'coins'
      });
    }
  },

  [OFFER_UPDATE_OPERATION]: (state, { quoteId, operationId, referenceNumber, partnerId }) => {
    state.idOffer = quoteId;
    state.idOperation = operationId;
    state.referenceNumber = referenceNumber;
    state.partnerId = partnerId;
  },

  [OFFER_UPDATE_OPERATION_ID]: (state, operationId) => {
    state.idOperation = operationId;
  },

  [OFFER_REGISTER_SIGNATURE]: (state, url) => {
    state.completedUrlDocument = url;
  },

  [OFFER_LEGAL_CONDITIONS]: (state, conditions) => {
    state.legalConditions = conditions;
  },

  [OFFER_CREATE_OPERATION_DATA]: (state, data) => {
    const sendData = data;
    delete sendData.signRequest;
    sendData.prospect.contact.forEach(element => {
      /* eslint-disable no-param-reassign */
      const { birthDate, documentType } = element;
      if (birthDate) {
        element.birthDate = dateToISO(birthDate);
      }
      if (!Number.isNaN(Number(element.documentType))) {
        element.documentType = Number(documentType);
      }
    });
    sendData.idC = state.idc;
    sendData.quoteId = state.idOffer;
    sendData.partnerId = state.partnerId;
    state.createOperationData = sendData;
  },

  [OFFER_UPDATE_SIGN]: (state, { guid, data }) => {
    const singRequest = data;
    singRequest.id = guid;
    state.singRequestData = singRequest;
  },

  [OFFER_UPDATE_DOCUMENTS_REQUIRED]: (state, data) => {
    state.documentsRequired = data;
  },

  [PRECONTRACT_UPDATE]: (state, precontract) => {
    state.precontract = precontract;
  },

  [OFFER_UPDATE_COMPLETED_KO]: (state, statusKo) => {
    state.statusKo = statusKo;
  },

  [OFFER_COMPONENTS_BY_PARTNER_ID]: (state, data) => {
    state.componentsCMS = data;
  },

  [OFFER_SET_GUID_URL]: (state, value) => {
    state.guidURL = value;
  },

  [SET_OFFERDETAIL_NAME]: (state, data) => {
    state.offerDetail.nameComplete = data;
  }
};
